import React, { useMemo } from 'react';

import { Button, makeStyles, Typography } from '@material-ui/core';
import ErrorIcon from '@material-ui/icons/Error';

import TableDense from '../common/TableDense';

const useStyles = makeStyles((theme) => ({
  container: {
    padding: '36px',
    [theme.breakpoints.up('lg')]: {
      padding: '30px',
      width: '700px',
    },
  },
  tableContainer: {
    marginTop: '12px',
  },
  tableSubdomainHeaderContent: {
    display: 'block',
    maxWidth: '280px',
    wordBreak: 'break-all',
  },
  typographyHeadTitle: {
    color: '#172B4D',
    fontSize: '24px',
    fontWeight: 'bold',
    lineHeight: '24px',
  },
  typographySubtitle: {
    color: '#999999',
    fontSize: '14px',
    lineHeight: '21px',
    marginBottom: '0px',
    marginTop: '12px',
  },
}));

const generateColumns = ({ classes }) => {
  return [
    {
      label: 'Partner Website',
      name: 'name',
    },
    {
      label: 'Sub Domain',
      name: 'subDomain',
      render: (value = '') => {
        const url = new URL(value);
        return <span className={classes.tableSubdomainHeaderContent}>{url.host}</span>;
      },
    },
    {
      label: '',
      name: 'id',
      render: (value, data) => {
        return (
          <Button variant="contained" color="primary" startIcon={<ErrorIcon />} href={data.subDomain} size="small" disableElevation>
            Click here to login
          </Button>
        );
      },
    },
  ];
};

export default ({ workspaces = [], email = '' }) => {
  const classes = useStyles();
  const columns = useMemo(() => {
    return generateColumns({ classes });
  }, [classes]);
  const options = useMemo(() => {
    return {
      count: workspaces.length,
    };
  }, [workspaces]);

  return (
    <div className={classes.container}>
      <Typography className={classes.typographyHeadTitle}>Login Info</Typography>
      <Typography className={classes.typographySubtitle}>
        Your email address &quot;{email}&quot; has not been registered on &nbsp;<a href="/">Mediphany.com</a>&nbsp; but has been registered on other partners of Mediphany listed
        below. To log into these partner&lsquo;s portals please click the relevant link below.
      </Typography>

      {/* TABLE */}
      <div className={classes.tableContainer}>
        <TableDense tableId="login-workspaces" count={workspaces.length || 0} options={options} columns={columns} data={workspaces || []} />
      </div>
      {/* TABLE END */}
    </div>
  );
};
